import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import WinnerSelectionPage from './Pages/WinnerSelectionPage';
import DefaultPage from './Pages/DefaultPage';

const SweepstakesWinnersRouter = () => {
    let { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={`${path}/:year/:month`}>
                <WinnerSelectionPage />
            </Route>
            <Route default>
                <DefaultPage />
            </Route>
        </Switch>
    );
};

export default SweepstakesWinnersRouter;
